import React from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Grid,
    TextField,
    IconButton,
    Tooltip,
    Collapse,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch } from 'common/components';
import AutocompleteField from 'common/components/AutocompleteField';

const BulkOperationsCard = ({ filterData, productBrands, setFilterData }) => {
    const { t } = useTranslation();
    const [filterIsOpen, setFilterIsOpen] = React.useState(false);
    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    const options = productBrands?.map(({ name }) => ({
        value: name,
        label: name,
    }));

    const handleOnChange = (name, value) =>
        setFilterData((prev) => ({ ...prev, page: 0, [name]: value }));

    return (
        <Box sx={{ mb: 2 }}>
            <Box
                container
                sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
                size={{ lg: 18, xs: 18 }}
            >
                <InputSearch
                    placeholder={t('Search')}
                    onChange={(e) =>
                        handleOnChange('searchText', e.target.value)
                    }
                    value={filterData?.searchText}
                    size={16}
                />
                <Tooltip title={t('Filter', { count: 2 })}>
                    <IconButton onClick={toggleFilter}>
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Collapse in={filterIsOpen} sx={{ width: '100%' }}>
                <Grid container mt={2} spacing={2}>
                    <Grid size={10}>
                        <AutocompleteField
                            label={t('Brand', { count: 1 })}
                            options={options}
                            onChange={(value) => handleOnChange('brand', value)}
                            value={filterData?.brand}
                            variant="outlined"
                        />
                    </Grid>

                    <Grid size={6}>
                        <TextField
                            fullWidth
                            label="W"
                            onChange={(e) =>
                                handleOnChange('max_power', e.target.value)
                            }
                            value={filterData?.max_power}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Collapse>
        </Box>
    );
};

BulkOperationsCard.propTypes = {
    filterData: PropTypes.object,
    productBrands: PropTypes.array,
    setFilterData: PropTypes.func,
};

export default BulkOperationsCard;
